import RadioGroup from '@/components/FormElements/RadioGroup';
import CustomListOption from '@/scenes/User/Settings/Privacy/AccessSettings/CustomListOption';
import {
  useActiveProfile,
  useTokenState
} from '@/store/localStorage/useTokenState';
import { selectActiveProfile } from '@/store/user/selectors/selectActiveProfile';
import { selectActiveProfileSettingsAugmented } from '@/store/user/selectors/selectActiveProfileSettingsAugmented';
import { updateProfileSetting } from '@/store/user/thunks/updateProfileSetting';
import {
  calculateReadAccessSettings,
  getCurrentAccessType
} from '@/utils/privacy/accessCalculation';
import { AccessType } from '@/utils/privacy/types/AccessType';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const commonPrivacyOptions = [
  {
    label: 'открыт всем',
    value: null // или вообще пустое
  },
  {
    label: 'открыт зарегистрированным',
    value: { type: AccessType.registered }
  },
  {
    label: 'открыт спискам',
    value: { type: AccessType.allowCustomList },
    component: () => (
      <CustomListOption accessType={AccessType.allowCustomList} />
    )
  },
  {
    label: 'закрыт спискам',
    value: { type: AccessType.denyCustomList },
    component: () => <CustomListOption accessType={AccessType.denyCustomList} />
  }
];

const commonOnlyPrivateOption = {
  label: 'закрыт от всех',
  value: { type: AccessType.private }
};

const privacyOptions = [
  ...commonPrivacyOptions,

  {
    label: 'открыт моим читателям',
    value: { type: AccessType.subscribers }
  },
  {
    label: 'открыт моим избранным',
    value: { type: AccessType.favorites }
  },
  commonOnlyPrivateOption
].map((option, index) => ({ ...option, radioValue: index }));

const communityPrivacyOptions = [
  ...commonPrivacyOptions,
  {
    label: 'открыт для читателей и участников',
    value: { type: AccessType.subscribers }
  },
  {
    label: 'открыт для участников',
    value: { type: AccessType.participants }
  },
  {
    label: 'открыт только для админов',
    value: { type: AccessType.admins }
  },
  commonOnlyPrivateOption
].map((option, index) => ({ ...option, radioValue: index }));

function getCheckedPermissionSetting(settings, isCommunity) {
  const options = isCommunity ? communityPrivacyOptions : privacyOptions;
  const typeToSearch = getCurrentAccessType(settings);

  return (
    options.find(option => option.value?.type === typeToSearch)?.radioValue ?? 0
  );
}

function PermissionSettings() {
  const dispatch = useDispatch();
  const [token] = useTokenState();
  const { activeProfileId } = useActiveProfile();

  const settings = useSelector(state =>
    selectActiveProfileSettingsAugmented(state, { activeProfileId })
  );
  const isCommunity = useSelector(
    state => selectActiveProfile(state, { activeProfileId })?.isCommunity
  );

  const [checkedPermissionSetting, setCheckedPermissionSetting] = useState(
    getCheckedPermissionSetting(settings, isCommunity)
  );

  const changeBlogPrivacySetting = (requestedAccessType, id) => {
    const newReadAccess = calculateReadAccessSettings(
      requestedAccessType,
      settings
    );

    dispatch(updateProfileSetting('permissions.access', newReadAccess, token));
    setCheckedPermissionSetting(id);
  };

  return (
    <>
      <RadioGroup
        title="ваш блог"
        name="blogPrivacyOptions"
        checked={checkedPermissionSetting}
        onCheck={changeBlogPrivacySetting}
        items={isCommunity ? communityPrivacyOptions : privacyOptions}
      />
    </>
  );
}

export default PermissionSettings;
